
export default {
	namespaced: true,
	state: {

	},

	actions: {
		fetchVersion ({ commit }, { projectId }) {
			return window.axios.get(`/ProjectStatistics/Version/Project/${projectId}`).then(({ data }) => {
				return data
			})
		},

		fetchBasicStat ({ commit }, { projectId, fromDate, toDate }) {
			return window.axios.get(`/ProjectStatistics/${projectId}`, { params: { fromDate, toDate } }).then(({ data }) => {
				return data
			})
		},

		fetchTagProject ({ commit }, { projectId, fromDate, toDate, tagId, annualy, withoutDuplicate }) {
			return window.axios.get('/Statistics/ProjectTagStatics', { params: { projectId, fromDate, toDate, tagId, annualy, withoutDuplicate } }).then(({ data }) => {
				return data
			})
		},

		fetchEmployeeTypeCountInProject ({ commit }, { projectId }) {
			return 	window.axios.get('/Statistics/EmployeeTypeCountInProject', { 
				params: { projectId } 
			}).then(({ data }) => {
				return data
			})
		},

		fetchProjectWorkAverage ({ commit }, { projectId, fromDate, toDate, annualy, withEmptyDates }) {
			return window.axios.get('/Statistics/GetProjectWorkAverage', { params: { projectId, fromDate, toDate, annualy, withEmptyDates } }).then(({ data }) => {
				return data
			})
		}
	}
}
